import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { IDefaultActionResult } from "../../../Orchestrator/Types/Interface/ActionParams/DefaultActionResult";


export class RetrieveBookingShowModalAction extends BaseAction<IDefaultActionResult, boolean> {

    override async run(): Promise<IDefaultActionResult | null> {
        const actionResult: IDefaultActionResult = {
            data: null,
            message: "",
            status: "fail"
        }
        try {
            updateRecoilState("retrieveFormAtom", {
                value: { bookingReference: "", lastName: "" },
                error: { bookingReference: "", lastName: "" },
            });
            updateRecoilState("isRetrieveModalOpenAtom", this.params)
            actionResult.status = "success"
        } catch (error) {

        } finally {
            return actionResult
        }
    }
}

export const retrieveBookingShowModalAction = new RetrieveBookingShowModalAction(); 